export enum StoryDisplay {
  Round = 'round',
  Square = 'square',
}

export enum StoryAnimation {
  Autoplay = 'autoplay',
  OnHover = 'onHover',
  Pulse = 'pulse',
}

export enum StoryWithShoppables {
  On = 'on',
  Off = 'off',
  OnActive = 'onActive',
}
